import classnames from 'classnames'
import { ReactNode } from 'react'

import styles from './ViewAllCriteria.module.scss'

interface IProps {
  specializationName: string
  requirementsCriteria: ReactNode
  thresholdsCriteria: ReactNode | undefined
  inline?: boolean
}

export const ViewAllCriteria = ({
  specializationName,
  requirementsCriteria,
  thresholdsCriteria,
  inline,
}: IProps) => {
  return (
    <div className={styles.container}>
      <div className={classnames(styles.header, styles.bottomWrapper)}>{specializationName}</div>

      <div className={classnames(styles.allCriteria, inline ? styles.inline : styles.block)}>
        <div
          className={classnames(styles.bottomWrapper, {
            [styles.eligibilityCriteria]: Boolean(inline),
          })}
        >
          {requirementsCriteria}
        </div>
        {thresholdsCriteria ? (
          <div className={styles.bottomWrapper}>{thresholdsCriteria}</div>
        ) : null}
      </div>
    </div>
  )
}
